// @flow
import { FormattedCurrency } from "../../../../../../components/FormattedCurrency/FormattedCurrency";

export const currencyFormatter = (value: string) => (
  <FormattedCurrency
    value={value}
    minimumFractionDigits={2}
    maximumFractionDigits={2}
    currency="GBP"
  />
);

export const columns = [
  {
    name: "City",
    accessor: "location_html",
  },
  {
    name: "Rental Cost Per Sq. m.",
    accessor: "cost_per_sq_metre",
    formatter: currencyFormatter,
  },
];

export const rows = [
  {
    location_html: <span>San Francisco, USA</span>,
    cost_per_sq_metre: 42.81,
    monthly_rental_single: 1669.59,
    yearly_income_single: 69086.52,
    monthly_rental_family: 3167.94,
    yearly_income_family: 131087.16,
  },
  {
    location_html: <span>New York City, USA</span>,
    cost_per_sq_metre: 41.03,
    monthly_rental_single: 1600.17,
    yearly_income_single: 66213.96,
    monthly_rental_family: 3036.22,
    yearly_income_family: 125636.64,
  },
  {
    location_html: <span>Hong Kong, Hong Kong</span>,
    cost_per_sq_metre: 33.14,
    monthly_rental_single: 1292.46,
    yearly_income_single: 53481.12,
    monthly_rental_family: 2452.36,
    yearly_income_family: 101476.92,
  },
  {
    location_html: <span>Dubai, UAE</span>,
    cost_per_sq_metre: 30.49,
    monthly_rental_single: 1189.11,
    yearly_income_single: 49204.56,
    monthly_rental_family: 2256.26,
    yearly_income_family: 93362.52,
  },
  {
    location_html: <span>Singapore, Singapore</span>,
    cost_per_sq_metre: 28.84,
    monthly_rental_single: 1124.76,
    yearly_income_single: 46541.76,
    monthly_rental_family: 2134.16,
    yearly_income_family: 88310.04,
  },
  {
    location_html: <span>Washington D.C., USA</span>,
    cost_per_sq_metre: 28.73,
    monthly_rental_single: 1120.47,
    yearly_income_single: 46364.28,
    monthly_rental_family: 2126.02,
    yearly_income_family: 87973.2,
  },
  {
    location_html: <span>Geneva, Switzerland</span>,
    cost_per_sq_metre: 26.66,
    monthly_rental_single: 1039.74,
    yearly_income_single: 43023.72,
    monthly_rental_family: 1972.84,
    yearly_income_family: 81634.8,
  },
  {
    location_html: <span>Sydney, Australia</span>,
    cost_per_sq_metre: 25.3,
    monthly_rental_single: 986.7,
    yearly_income_single: 40828.92,
    monthly_rental_family: 1872.2,
    yearly_income_family: 77470.32,
  },
  {
    location_html: <span>Zurich, Switzerland</span>,
    cost_per_sq_metre: 25.19,
    monthly_rental_single: 982.41,
    yearly_income_single: 40651.44,
    monthly_rental_family: 1864.06,
    yearly_income_family: 77133.48,
  },
  {
    location_html: <span>Los Angeles, USA</span>,
    cost_per_sq_metre: 24.75,
    monthly_rental_single: 965.25,
    yearly_income_single: 39941.4,
    monthly_rental_family: 1831.5,
    yearly_income_family: 75786.24,
  },
  {
    location_html: (
      <span>
        London, UK
        <sup>3</sup>
      </span>
    ),
    cost_per_sq_metre: 24.71,
    monthly_rental_single: 963.69,
    yearly_income_single: 39876.84,
    monthly_rental_family: 1828.54,
    yearly_income_family: 75663.72,
  },
  {
    location_html: <span>Miami, USA</span>,
    cost_per_sq_metre: 24.53,
    monthly_rental_single: 956.67,
    yearly_income_single: 39586.32,
    monthly_rental_family: 1815.22,
    yearly_income_family: 75112.56,
  },
  {
    location_html: <span>Chicago, USA</span>,
    cost_per_sq_metre: 21.52,
    monthly_rental_single: 839.28,
    yearly_income_single: 34728.84,
    monthly_rental_family: 1592.48,
    yearly_income_family: 65895.72,
  },
  {
    location_html: <span>Copenhagen, Denmark</span>,
    cost_per_sq_metre: 20.4,
    monthly_rental_single: 795.6,
    yearly_income_single: 32921.4,
    monthly_rental_family: 1509.6,
    yearly_income_family: 62466.24,
  },
  {
    location_html: <span>Tokyo, Japan</span>,
    cost_per_sq_metre: 20.2,
    monthly_rental_single: 787.8,
    yearly_income_single: 32598.6,
    monthly_rental_family: 1494.8,
    yearly_income_family: 61853.76,
  },
  {
    location_html: <span>Vancouver, Canada</span>,
    cost_per_sq_metre: 20.0,
    monthly_rental_single: 780.0,
    yearly_income_single: 32275.92,
    monthly_rental_family: 1480.0,
    yearly_income_family: 61241.4,
  },
  {
    location_html: <span>Amsterdam, Netherlands</span>,
    cost_per_sq_metre: 19.54,
    monthly_rental_single: 762.06,
    yearly_income_single: 31533.48,
    monthly_rental_family: 1445.96,
    yearly_income_family: 59832.84,
  },
  {
    location_html: <span>Paris, France</span>,
    cost_per_sq_metre: 18.93,
    monthly_rental_single: 738.27,
    yearly_income_single: 30549.12,
    monthly_rental_family: 1400.82,
    yearly_income_family: 57964.92,
  },
  {
    location_html: <span>Melbourne, Australia</span>,
    cost_per_sq_metre: 18.18,
    monthly_rental_single: 709.02,
    yearly_income_single: 29338.8,
    monthly_rental_family: 1345.32,
    yearly_income_family: 55668.36,
  },
  {
    location_html: <span>Oslo, Norway</span>,
    cost_per_sq_metre: 17.39,
    monthly_rental_single: 678.21,
    yearly_income_single: 28063.92,
    monthly_rental_family: 1286.86,
    yearly_income_family: 53249.4,
  },
  {
    location_html: <span>Reykjavik, Iceland</span>,
    cost_per_sq_metre: 17.34,
    monthly_rental_single: 676.26,
    yearly_income_single: 27983.16,
    monthly_rental_family: 1283.16,
    yearly_income_family: 53096.28,
  },
  {
    location_html: <span>Stockholm, Sweden</span>,
    cost_per_sq_metre: 17.28,
    monthly_rental_single: 673.92,
    yearly_income_single: 27886.32,
    monthly_rental_family: 1278.72,
    yearly_income_family: 52912.56,
  },
  {
    location_html: <span>Dublin, Ireland</span>,
    cost_per_sq_metre: 16.81,
    monthly_rental_single: 655.59,
    yearly_income_single: 27127.92,
    monthly_rental_family: 1243.94,
    yearly_income_family: 51473.4,
  },
  {
    location_html: <span>Seoul, South Korea</span>,
    cost_per_sq_metre: 16.36,
    monthly_rental_single: 638.04,
    yearly_income_single: 26401.68,
    monthly_rental_family: 1210.64,
    yearly_income_family: 50095.44,
  },
  {
    location_html: <span>Toronto, Canada</span>,
    cost_per_sq_metre: 16.32,
    monthly_rental_single: 636.48,
    yearly_income_single: 26337.12,
    monthly_rental_family: 1207.68,
    yearly_income_family: 49972.92,
  },
  {
    location_html: <span>Auckland, New Zealand</span>,
    cost_per_sq_metre: 16.24,
    monthly_rental_single: 633.36,
    yearly_income_single: 26208.0,
    monthly_rental_family: 1201.76,
    yearly_income_family: 49728.0,
  },
  {
    location_html: <span>Brisbane, Australia</span>,
    cost_per_sq_metre: 16.12,
    monthly_rental_single: 628.68,
    yearly_income_single: 26014.32,
    monthly_rental_family: 1192.88,
    yearly_income_family: 49360.56,
  },
  {
    location_html: <span>Helsinki, Finland</span>,
    cost_per_sq_metre: 15.92,
    monthly_rental_single: 620.88,
    yearly_income_single: 25691.64,
    monthly_rental_family: 1178.08,
    yearly_income_family: 48748.08,
  },
  {
    location_html: <span>Beijing, China</span>,
    cost_per_sq_metre: 15.8,
    monthly_rental_single: 616.2,
    yearly_income_single: 25497.96,
    monthly_rental_family: 1169.2,
    yearly_income_family: 48380.64,
  },
  {
    location_html: <span>Perth, Australia</span>,
    cost_per_sq_metre: 15.48,
    monthly_rental_single: 603.72,
    yearly_income_single: 24981.48,
    monthly_rental_family: 1145.52,
    yearly_income_family: 47400.84,
  },
  {
    location_html: <span>Munich, Germany</span>,
    cost_per_sq_metre: 15.26,
    monthly_rental_single: 595.14,
    yearly_income_single: 24626.52,
    monthly_rental_family: 1129.24,
    yearly_income_family: 46727.16,
  },
  {
    location_html: <span>Shanghai, China</span>,
    cost_per_sq_metre: 15.17,
    monthly_rental_single: 591.63,
    yearly_income_single: 24481.2,
    monthly_rental_family: 1122.58,
    yearly_income_family: 46451.64,
  },
  {
    location_html: <span>Milan, Italy</span>,
    cost_per_sq_metre: 15.0,
    monthly_rental_single: 585.0,
    yearly_income_single: 24206.88,
    monthly_rental_family: 1110.0,
    yearly_income_family: 45931.08,
  },
  {
    location_html: <span>Rome, Italy</span>,
    cost_per_sq_metre: 14.54,
    monthly_rental_single: 567.06,
    yearly_income_single: 23464.56,
    monthly_rental_family: 1075.96,
    yearly_income_family: 44522.52,
  },
  {
    location_html: <span>Tel Aviv, Israel</span>,
    cost_per_sq_metre: 14.51,
    monthly_rental_single: 565.89,
    yearly_income_single: 23416.08,
    monthly_rental_family: 1073.74,
    yearly_income_family: 44430.6,
  },
  {
    location_html: <span>Frankfurt am Main, Germany</span>,
    cost_per_sq_metre: 13.71,
    monthly_rental_single: 534.69,
    yearly_income_single: 22125.12,
    monthly_rental_family: 1014.54,
    yearly_income_family: 41980.92,
  },
  {
    location_html: <span>Edinburgh, UK</span>,
    cost_per_sq_metre: 12.85,
    monthly_rental_single: 501.15,
    yearly_income_single: 20737.2,
    monthly_rental_family: 950.9,
    yearly_income_family: 39347.64,
  },
  {
    location_html: <span>Dusseldorf, Germany</span>,
    cost_per_sq_metre: 12.68,
    monthly_rental_single: 494.52,
    yearly_income_single: 20462.88,
    monthly_rental_family: 938.32,
    yearly_income_family: 38827.08,
  },
  {
    location_html: <span>Madrid, Spain</span>,
    cost_per_sq_metre: 12.04,
    monthly_rental_single: 469.56,
    yearly_income_single: 19430.04,
    monthly_rental_family: 890.96,
    yearly_income_family: 36867.36,
  },
  {
    location_html: <span>Hamburg, Germany</span>,
    cost_per_sq_metre: 11.99,
    monthly_rental_single: 467.61,
    yearly_income_single: 19349.4,
    monthly_rental_family: 887.26,
    yearly_income_family: 36714.24,
  },
  {
    location_html: <span>Vienna, Austria</span>,
    cost_per_sq_metre: 11.88,
    monthly_rental_single: 463.32,
    yearly_income_single: 19171.92,
    monthly_rental_family: 879.12,
    yearly_income_family: 36377.4,
  },
  {
    location_html: <span>Taipei, Taiwan</span>,
    cost_per_sq_metre: 11.88,
    monthly_rental_single: 463.32,
    yearly_income_single: 19171.92,
    monthly_rental_family: 879.12,
    yearly_income_family: 36377.4,
  },
  {
    location_html: <span>Brussels, Belgium</span>,
    cost_per_sq_metre: 11.85,
    monthly_rental_single: 462.15,
    yearly_income_single: 19123.44,
    monthly_rental_family: 876.9,
    yearly_income_family: 36285.48,
  },
  {
    location_html: <span>Moscow, Russia</span>,
    cost_per_sq_metre: 11.6,
    monthly_rental_single: 452.4,
    yearly_income_single: 18720.0,
    monthly_rental_family: 858.4,
    yearly_income_family: 35520.0,
  },
  {
    location_html: <span>Bristol, UK</span>,
    cost_per_sq_metre: 11.22,
    monthly_rental_single: 437.58,
    yearly_income_single: 18106.8,
    monthly_rental_family: 830.28,
    yearly_income_family: 34356.36,
  },
  {
    location_html: <span>Berlin, Germany</span>,
    cost_per_sq_metre: 10.81,
    monthly_rental_single: 421.59,
    yearly_income_single: 17445.12,
    monthly_rental_family: 799.94,
    yearly_income_family: 33100.92,
  },
  {
    location_html: <span>Southampton, UK</span>,
    cost_per_sq_metre: 10.68,
    monthly_rental_single: 416.52,
    yearly_income_single: 17235.36,
    monthly_rental_family: 790.32,
    yearly_income_family: 32702.88,
  },
  {
    location_html: <span>Osaka, Japan</span>,
    cost_per_sq_metre: 10.29,
    monthly_rental_single: 401.31,
    yearly_income_single: 16605.96,
    monthly_rental_family: 761.46,
    yearly_income_family: 31508.64,
  },
  {
    location_html: <span>Jakarta, Indonesia</span>,
    cost_per_sq_metre: 10.28,
    monthly_rental_single: 400.92,
    yearly_income_single: 16589.76,
    monthly_rental_family: 760.72,
    yearly_income_family: 31478.04,
  },
  {
    location_html: <span>Barcelona, Spain</span>,
    cost_per_sq_metre: 10.27,
    monthly_rental_single: 400.53,
    yearly_income_single: 16573.68,
    monthly_rental_family: 759.98,
    yearly_income_family: 31447.44,
  },
];
